import * as React from 'react';
import MediaQuery from 'react-responsive';
import Anchor from '@telia-front/anchor';
import Grid, { GridColumn } from '@telia-front/grid';
import { Icon } from '@telia-front/icon';
import List, { ListItem } from '@telia-front/list';
import ScrollFade from '@telia-front/scroll-fade';
import { useTheme } from '@telia-front/theme-provider';
const HeaderSegment = (props) => {
    const { media } = useTheme();
    const BEM = () => {
        const classArray = ['header__segment'];
        if (props.color) {
            classArray.push('header__segment--' + props.color);
        }
        return classArray.join(' ');
    };
    const segmentItemBEM = (item) => {
        const classArray = [];
        if (item.icon) {
            classArray.push('header__segment-item-with-icon');
        }
        else {
            classArray.push('header__segment-item');
        }
        if (item.current) {
            classArray.push('is-current');
        }
        if (item.employee) {
            classArray.push('is-employee');
        }
        return classArray.join(' ');
    };
    const getItems = () => {
        return props.items.map((item, index) => {
            const itemLabel = item.mobileLabel ? (React.createElement(MediaQuery, { minWidth: media.width.sm.min }, matches => React.createElement("div", null, matches ? item.label : item.mobileLabel))) : (item.label);
            return (React.createElement(ListItem, { className: segmentItemBEM(item), key: index },
                React.createElement(Anchor, { url: item.url, isUnderlined: false, onClick: item.onClick, className: "header__segment-link", attributes: {
                        'aria-current': item.current ? 'true' : undefined,
                    } }, item.icon ? (React.createElement(Grid, { noWrap: true, align: ['middle-xs'], gutter: "none" },
                    React.createElement(GridColumn, { width: ['min'] },
                        React.createElement(Icon, Object.assign({}, item.icon, { className: "header__segment-icon" }))),
                    React.createElement(GridColumn, { width: ['max'] }, itemLabel))) : (itemLabel))));
        });
    };
    const list = (React.createElement(List, { type: "unstyled", direction: "inline", noGutter: "all", fullWidth: true, className: "header__segment-list" }, getItems()));
    return React.createElement("div", { className: BEM() }, props.scrollable ? React.createElement(ScrollFade, null, list) : list);
};
export default HeaderSegment;
